import { render, staticRenderFns } from "./CardDetailPayment.vue?vue&type=template&id=c796ce92"
import script from "./CardDetailPayment.vue?vue&type=script&lang=js"
export * from "./CardDetailPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports